import React from 'react';
import styles from './MentionsLegales.module.scss';

const MentionsLegales = () => (
  <div className={styles.content} id="mentions-legales">
    <h2>Mentions légales et information du consommateur</h2>

    <h3>1. Éditeur du site</h3>
    <p><strong>Dénomination</strong> : Nounou Chou Express</p>
    <p><strong>Forme juridique</strong> : Entreprise individuelle (EI)</p>
    <p><strong>SIRET</strong> : 892 986 415 00016</p>
    <p><strong>Siège</strong> : 95610 Éragny, France</p>
    <p><strong>Téléphone</strong> : <a href="tel:0664953123">06 64 95 31 23</a></p>
    <p><strong>Email</strong> : <a href="mailto:nounou.chou95@hotmail.com">nounou.chou95@hotmail.com</a></p>
    <p>
      <strong>Directeur de la publication</strong> : le responsable de Nounou Chou Express,
      entrepreneur individuel.
    </p>
    <p><strong>Site réalisé par</strong> : <a href="https://www.pikcel.fr" target="_blank" rel="noopener noreferrer">pikcel.fr</a></p>

    <h3>2. Hébergeur</h3>
    <p><strong>Hébergeur</strong> : Hostinger</p>
    <p>Hostinger International, 61-63 rue de la Victoire, 75009 Paris, France</p>
    <p>Téléphone : +33 1 70 18 99 10</p>

    <h3>3. Services à la personne</h3>
    <p>
      Nounou Chou Express est un organisme de services à la personne.
      Le numéro de déclaration ou d'agrément est communiqué sur le devis et sur la facture.
    </p>
    <p>
      <strong>Mode d'intervention :</strong> prestataire.
      Nounou Chou Express fournit la prestation et facture le client.
      Le client n'est pas l'employeur de l'intervenant pour les réservations réalisées via ce site.
    </p>

    <h3>4. Prestations proposées</h3>
    <p>
      Activités au sens de l'article D. 7231-1 du code du travail :
    </p>
    <ul>
      <li>
        <strong>Garde d'enfants à domicile et accompagnement des enfants</strong> :
        garde du matin, avant l'école, après l'école, du soir, à la journée,
        remplacement d'urgence, contrat de longue durée.
      </li>
      <li>
        <strong>Soutien scolaire à domicile</strong> : aide aux devoirs.
      </li>
      <li>
        <strong>Entretien de la maison et travaux ménagers</strong> : aide ménagère.
      </li>
    </ul>
    <p>
      Zone d'intervention : Éragny (95610) et un rayon de 15 km.
      Horaires habituels de garde : de 6h00 à 23h00, hors dimanche.
    </p>

    <h3>5. Prix</h3>
    <p>
      Tarif des prestations de garde d'enfants réservées en ligne :
      <strong> 29,99 € TTC / heure</strong> (prix toutes taxes comprises).
    </p>
    <p>
      Les créneaux se facturent par tranche de 30 minutes.
      Sauf mention contraire sur devis, aucun frais de dossier ni de déplacement
      n'est ajouté au tarif horaire.
    </p>
    <p>
      Les contrats de longue durée font l'objet d'un devis personnalisé.
    </p>

    <h3>6. Devis et facture</h3>
    <p>
      Le vendeur remet gratuitement un devis personnalisé au consommateur à qui il propose
      une prestation ou un ensemble de prestations dont le prix total est supérieur ou égal
      à 100 € TTC, ou au consommateur qui lui en fait la demande.
    </p>
    <p>La facture est remise gratuitement, sur support durable.</p>

    <h3>7. Conditions de réservation en ligne</h3>
    <p>
      La réservation d'une garde d'urgence se fait via le formulaire du site.
      Le paiement par carte, avant la prestation, est obligatoire pour confirmer la réservation.
    </p>
    <p>
      Âge minimum des enfants : 3 ans.
      Une garde le jour même doit être demandée au moins 5 heures avant le début.
      Une garde pour le lendemain est possible jusqu'à 17h la veille.
    </p>
    <p>
      Conformément à l'article L. 221-28 du code de la consommation, le droit de rétractation
      ne s'applique pas aux prestations de garde convenues pour une date et un horaire précis.
    </p>

    <h3>8. Données personnelles</h3>
    <p>
      Les données collectées (identité, coordonnées, adresse, informations sur les enfants,
      besoins de garde) servent uniquement au traitement des réservations, devis et demandes
      de contact.
    </p>
    <p>
      Elles peuvent être transmises aux prestataires techniques nécessaires :
      EmailJS (confirmation de réservation), Formspree (formulaires de contact et de devis),
      Stripe (paiement), OpenCage (vérification de la zone d'intervention)
      et Google Analytics (mesure d'audience).
    </p>
    <p>
      Vous pouvez demander l'accès, la rectification ou la suppression de vos données
      à <a href="mailto:nounou.chou95@hotmail.com">nounou.chou95@hotmail.com</a>.
    </p>
    <p>
      Le site peut utiliser une mesure d'audience uniquement si vous l'acceptez.
      Vous pouvez modifier votre choix à tout moment grâce au lien « Personnaliser ses cookies »
      en bas de page.
    </p>

    <h3>9. Propriété intellectuelle</h3>
    <p>
      Le site et son contenu (textes, images, logos) sont protégés.
      Toute reproduction non autorisée est interdite.
    </p>
  </div>
);

export default MentionsLegales;
